import MatchedOpportunitiesEmptyState from './MatchedOpportunitiesEmptyState.component';

export default MatchedOpportunitiesEmptyState;